import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import Layout from '../layout';
import BaseCheckoutLayout from './base-checkout-layout';
import OrderPanelView from '../order/panel-view';

class CheckoutSuccessPage extends Component {
    constructor(props) {
        super(props);

        document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
    }

    /* Render this step only if order is present and in a valid checkout state. */
    componentWillMount() {
        if (this.props.currentCheckoutStep === 'complete') {
            const dupeOrder = { ...this.props.order };
            this.props.saveOrderAsPlaced(dupeOrder);
        } else if (!this.props.placedOrder.id) {
            this.props.handleCheckoutStepNotEditable(this.props.order);
        }
    }

    componentDidMount() {
        if (this.props.currentCheckoutStep === 'complete') {
            this.props.clearOrder();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'checkout', defaultMessage: 'Checkout' });
        }
    }

    render() {
        return (
            <Layout>
                <BaseCheckoutLayout
                    currentStep="complete"
                    displayLoader={this.props.displayLoader}
                    checkoutSteps={this.props.placedOrder.checkout_steps || []}
                    placedOrder={this.props.placedOrder}
                    order={this.props.order}
                >
                    <div className="checkout-confirmation-block">
                        <strong className="text text-success confirmation-success-message">
                            <FormattedMessage id="successMessage" defaultMessage="Your Order has been placed successfully!" />
                        </strong>
                        <OrderPanelView order={this.props.placedOrder} stores={this.props.stores} locale={this.props.intl.locale} />
                    </div>
                </BaseCheckoutLayout>
            </Layout>
        );
    }
}

export default injectIntl(CheckoutSuccessPage);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/checkout-success-page.jsx
 **/